import { render, staticRenderFns } from "./DosyaKapatmaNedenleriPicker.vue?vue&type=template&id=a6736728"
import script from "./DosyaKapatmaNedenleriPicker.vue?vue&type=script&lang=ts"
export * from "./DosyaKapatmaNedenleriPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports